import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-fa_home",
  "use": "icon-fa_home-usage",
  "viewBox": "160 200 640 520",
  "content": "<symbol viewBox=\"160 200 640 520\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-fa_home\">\r\n  <path d=\"M180 430L480 220L780 430M730 430V660C730 682.091 712.091 700 690 700H270C247.909 700 230 682.091 230 660V430M380 700V530C380 507.909 397.909 490 420 490H540C562.091 490 580 507.909 580 530V700\" stroke=\"#555970\" stroke-width=\"24\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/fa_home.svg
// module id = V/Cg
// module chunks = 63